import statusIndex from 'data/commerce-status-index'

const commerceStatusCodes = [
	...Object.keys(statusIndex).map((key) => ({
		value: key,
		label: statusIndex[key].text,
	})),
]

export default commerceStatusCodes;